import { JOURNAL_PLANNER_FEATURE_KEY, JourneyPlannerState } from './journey-planner.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const journeyPlannerState = createFeatureSelector<JourneyPlannerState>(JOURNAL_PLANNER_FEATURE_KEY);
export const favoriteStops = createSelector(journeyPlannerState, (state: JourneyPlannerState) => state.favoriteStops);
